import { ValueGetterParams } from "ag-grid-community"
import { checkboxColDefCreator, datetimeColDefCreator, modifyButtonColDefCreator, numberColDefCreator, stringColDefCreator } from "./standard-col-def-creators"
import { EodQuestionsSettingsHeader } from "../custom-headers/eod-questions-settings-header"
import { EodQuestionRowData } from "../../../forms/EodQuestionForm/types"
import EodQuestionIconCellRenderer from "../cell-renderers/EodQuestionIconCellRenderer"
import { isActiveEnumValueFormatter } from "../../../common/ag-grid-value-formatters"

/**
 * Settings for the EoD Question Library company-admin page: one row per question in the
 * company's library, following the same CustomDashboard pattern as rate tables.
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getEodQuestionsSettings = () => {
    return {
        tableName: "End of Day Questions",
        navId: "eodQuestions",
        resources: ["eodQuestions"],
        filters: [],
        colDefs: [
            checkboxColDefCreator({
                width: 60,
                headerCheckboxSelection: true,
                pinned: "left",
            }),
            {
                headerName: "Icon",
                field: "/icon",
                width: 70,
                editable: false,
                sortable: false,
                filter: false,
                cellRenderer: EodQuestionIconCellRenderer,
            },
            stringColDefCreator({
                headerName: "Title",
                field: "/title",
                width: 250,
                pinned: "left",
            }),
            stringColDefCreator({
                headerName: "Category",
                field: "/subtitle",
                width: 200,
            }),
            stringColDefCreator({
                headerName: "Question Text",
                field: "/prompt_text",
                width: 400,
            }),
            numberColDefCreator({
                headerName: "Answers",
                editable: false,
                width: 110,
                valueGetter: (params: ValueGetterParams) => (params.data as EodQuestionRowData).answer_choices.length,
            }),
            {
                ...stringColDefCreator({
                    headerName: "Status",
                    field: "/is_active",
                    enum: ["Active", "Inactive"],
                    editable: false,
                    minWidth: 100,
                    width: 100,
                }),
                valueFormatter: isActiveEnumValueFormatter,
            },
            datetimeColDefCreator({
                headerName: "Last Updated",
                field: "/last_updated",
                editable: false,
                width: 220,
            }),
            {
                ...modifyButtonColDefCreator({
                    modifyFlow: "EOD_QUESTION_MODIFY",
                    headerName: "Settings",
                }),
                field: "/settings",
                // Prevent AG-Grid from intercepting clicks meant for the Modify button
                editable: false,
                excludeFromExport: true,
            },
        ],
        gridSettings: {
            rowHeight: 40,
            defaultColDef: {
                editable: true,
                filter: true,
                sortable: true,
            },
            rowSelection: "multiple",
        },
        otherSettings: {
            customHeaderComponent: EodQuestionsSettingsHeader,
            buttons: {
                row: [
                    {
                        label: "Activate",
                        icon: "view",
                        action: "bulkUpdateEodQuestionsIsActive",
                        args: { is_active: true },
                    },
                    {
                        label: "Deactivate",
                        icon: "hide",
                        action: "bulkUpdateEodQuestionsIsActive",
                        args: { is_active: false },
                    },
                ],
            },
        },
    }
}
